export default (user, roles) => {
  if (!user) return false;
  if (!(roles instanceof Array))
    roles = [roles];
  return roles.some(role => ~user.ivGroups.indexOf(role));
}



// WEBPACK FOOTER //
// ./src/util/hasRole.js